export type ConsoleRole = string | null | undefined;

export const isAdminRole = (role: ConsoleRole): boolean =>
  role === "admin" || role === "superadmin";

export const isSuperAdminRole = (role: ConsoleRole): boolean =>
  role === "superadmin";
